// The payload is the deleted organization's id, wrapped in an object: synapse's `DefaultPayload`
// requires `payload` to be a record (or an array of records), never a bare primitive.
export type OrganizationDeletedPayload = {
	organizationId: number;
};

export type OrganizationDeletedAction = {
	type: 'ORGANIZATION_DELETED';
	payload: OrganizationDeletedPayload;
	accountId: number;
};

export default (payload: OrganizationDeletedPayload, accountId: number): OrganizationDeletedAction => ({
	type: 'ORGANIZATION_DELETED',
	payload,
	accountId,
});
